<template>
    <div id="app">
        <keep-alive>
            <!-- 需要缓存的视图组件 -->
            <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive"></router-view>
            <!-- <router-view></router-view> -->
        </keep-alive>
        <!-- 不需要缓存、的视图组件 -->
        <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive"></router-view>
        <van-overlay :show="$store.state.shows">
            <div class="wrapper" @click.stop>
                <van-loading size="0.3rem" class="JZ" vertical>加载中...</van-loading>
            </div>
        </van-overlay>
       <!-- <div class="kefu_icon" @touchstart="getTouchStart" @touchend="getTouchEnd" v-if="$store.state.flags && $route.path != '/seckill'">
            <van-icon v-if="$store.state.flag1" class="icons" @click="close()" name="close" size="0.2rem" />
            <div @click="kefu()" class="divs"></div>
            <van-badge class="badge" v-if="$store.state.kfNum!=0" :content="$store.state.kfNum"></van-badge>
            <img :src="require('./assets/img/kf/kf.png')" alt="">
        </div> -->
        <van-overlay :show="shows" @click="shows = false">
            <div class=" wrapper1" @click.stop>
                <div class="count">
					<van-icon class="closeBtn" @click="closeTel" name="close"/>
					<img src="@/assets/img/new/myshop/cont.png" />
					<p class="p1">13007672511</p>
					<p class="p2">工作时间：周一至周五 9:00-18:00</p>
					<p class="p2">(节假日除外)</p>
					<van-button class="btn" size="small" color="#888888" plain round type="default" @click="ZX()">在线客服</van-button>
					<a class="btn btns" :href="'tel:' + 13007672511">马上联系</a>
					
                   <!-- <p>老师您好，需要立即致电我们的客服专员吗？</p>
                    <van-button class="btn" size="small" color="#888888" plain round type="default" @click="ZX()">在线客服</van-button>
                    <a class="btn btns" :href="'tel:' + 18790275611">马上联系</a> -->
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import myaxios from './components/api/api';
import wx from "weixin-js-sdk";
export default {
    name: "App",
    data() {
        return {
            shows: false,
            loop: "",
            websock: null, // ws实例
            timer: "",
        }
    },
    // watch: {
    //     "$store.state.informationFlag"() {
    //         if (this.$store.state.informationFlag) {
    //             this.initWebSocket()
    //             this.$store.state.informationFlag = false
    //         }
    //     }
    // },
    created() {
        clearTimeout(this.$store.state.timers)
        if (this.$store.state.buyerId) {
            // this.initWebSocket()
        }else{
             clearTimeout(this.$store.state.timers)
        }
    },
    methods: {
		closeTel(){
			this.shows = false
		},
        //--------------------------------------------
        initWebSocket() {
            this.websock = new WebSocket(this.wsUrl)
            this.websock.onmessage = this.websocketonmessage
            this.websock.onopen = this.websocketonopen
        },
        websocketonopen() {
            // 连接建立之后执行send方法发送数据
				let actions = { "userId": this.$store.state.buyerId, "content": "", "type": "heart" }
				this.websocketsend(JSON.stringify(actions))
				this.$store.state.timers = setInterval(() => {
                let actions = { "userId": this.$store.state.buyerId, "content": "", "type": "heart" }
                this.websocketsend(JSON.stringify(actions))
            }, 60000);
        },
        websocketonmessage(e) {
            // 数据接收
            const redata = JSON.parse(e.data)
            this.heard(redata.msgId,redata.msg)
        },
        websocketsend(Data) {
            // 数据发送
            this.websock.send(Data)
        },
        heard(msgId,msg) {
            const params = `msgId=${msgId}`
            myaxios.receiptMsg(params).then(res => {
                if (msg=='SP100000') {
                    this.kefy();
                }else{
                    this.tips()
                }
            })
        },
        //--------------------------------------------
        kefu() {
            this.shows = true
			
			
			// var ua = window.navigator.userAgent.toLowerCase();
			// if (ua.match(/MicroMessenger/i) == "micromessenger") {
			// 	//微信环境下
			// 	// alert("微信环境");
			// 	wx.miniProgram.getEnv((res) => {
			// 		if (res.miniprogram) {
			// 			// 小程序环境下逻辑
			// 			// alert("小程序环境");
			// 			wx.miniProgram.navigateTo({
			// 				//这将唤起小程序的原生页面
			// 				url: `/pages/customer/customer`,
			// 				success: (res) => {},
			// 			});
			// 		}
			// 	});
			// } else {
			// 	location.href = 'weixin://dl/business/?appid=wx8642be66812da3a3&path=pages/customer/customer&env_version=release' // 拼接到 query的后面﻿  正式版为"release"，体验版为"trial"，开发版为"develop"
			// }
			
        },
        kefy() {
            myaxios.getMsgShop('shopId=SP100000').then(res => {
                if (res.data.status == 200) {
                    if (res.data.total != 0) {
                        this.$store.state.kfNum = res.data.rows[0].msgNum2
                    } else {
                        this.$store.state.kfNum = 0
                    }
                }
            })
        },
        tips() {
            myaxios.getUnreadMsgNum().then(res => {
                if (res.status == 200) {
                    this.$store.state.kefuNum = res.data;
                    if (res.data.status == 400) {
                        localStorage.removeItem("userInfo")
                        this.$router.replace(`/login`)
                    }
                }
            });
        },
        getTouchStart() {
            clearTimeout(this.loop);//再次清空定时器，防止重复注册定时器

            this.loop = setTimeout(() => {
                if (this.$store.state.flag1) {
                    this.$store.state.flag1 = false
                } else {
                    this.$store.state.flag1 = true

                }
            }, 1000);
        },
        getTouchEnd() {
            clearTimeout(this.loop);
        },
        close() {
            localStorage.setItem("kefu", true)
            this.$store.state.flags = false
        },
        ZX() {
            // this.$router.push(`/customer`)
			
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
				//微信环境下
				// alert("微信环境");
				wx.miniProgram.getEnv((res) => {
					if (res.miniprogram) {
						// 小程序环境下逻辑
						// alert("小程序环境");
						wx.miniProgram.navigateTo({
							//这将唤起小程序的原生页面
							url: `/pages/customer/customer`,
							success: (res) => {},
						});
					}
				});
			} else {
				location.href = 'weixin://dl/business/?appid=wx8642be66812da3a3&path=pages/customer/customer&env_version=release' // 拼接到 query的后面﻿  正式版为"release"，体验版为"trial"，开发版为"develop"
			}
			
            this.shows = false
        }
    },
    mounted() {
        window.onload = function () {
            document.addEventListener('touchstart', function (e) {
                if (e.touches.length > 1) {
                    e.preventDefault()
                }
            })
            document.addEventListener('gesturestart', function (e) {
                e.preventDefault()
            })
        }
    }
};
</script>

<style lang="scss" scoped>
@import "./assets/scss/index.scss";
* {
    margin: 0;
    padding: 0;

}

// 首页置灰 一屏
// #app::before {
//     content: "";
//     position: absolute;
//     inset: 0;
//     backdrop-filter: grayscale(1);
//     z-index: 99999;
// 　　pointer-events: none;
// }

#app {
    color: $color;
    background-color: $Z-bgc;
    font-family: $fontFamily;
	
	// position: relative;
	// width: 100%;
	// height: 100%;
	// overflow: scroll;
	
	.wrapper{
		@include positionTop(0, 0, 0);
		margin: auto;
		width: 3rem;
		bottom: 0;
		height: 1.5rem;
	}
    .wrapper1 {
        // @include positionTop(0, 0, 0);
        // margin: auto;
        // width: 3rem;
		
		text-align: center;
		padding-top: 2.2rem;
		height: 100%;
		position: relative;
		
        .count {
			margin: 0 auto;
			// 弹窗的适配
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			
			
            // position: relative;
            width: 3rem;
            background-color: #fff;
            border-radius: 0.1rem;
            padding: 0.2rem;
            text-align: center;
            // margin-top: 2rem;
			.closeBtn{
			  position: absolute;
			  top: 0.1rem;
			  right: 0.1rem;
			  font-size: 0.2rem;
			}
			img {
			  width: 1rem;
			  height: 1rem;
			}
			.p1 {
			  color: #000;
			  font-size: 0.22rem;
			  font-weight: 600;
			}
			.p2 {
			  color: #848484;
			  font-size: 0.12rem;
			  font-weight: 600;
			  margin-top: 0.1rem;
			}
			
			.btn {
			    margin-top: 0.3rem;
			    margin-left: 0.2rem;
			    width: 0.9rem;
			    vertical-align: middle;
			}
			.btns {
			    display: inline-block;
			    height: 0.32rem;
			    line-height: 0.32rem;
			    background-image: linear-gradient(to right, #ff6034, #ee0a24);
			    color: #fff;
			    border-radius: 20px;
			    vertical-align: middle;
			    text-align: center;
			    font-size: $fontSizeSmall;
			}
			
        }
    }
    .kefu_icon {
        position: fixed;
        left: 0.02rem;
        bottom: 3.5rem;
		// top: 0.1rem;
		
        width: 0.35rem;
        height: 0.35rem;
        background-color: $priceColor;
        border-radius: 50%;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        z-index: 9999999;
        .badge {
            position: absolute;
            top: -0.05rem;
            right: -0.05rem;
        }
        .icons {
            position: absolute;
            right: -0.15rem;
            bottom: -0.1rem;
            color: #000;
        }
        img {
            display: block;
            width: 0.3rem;
            height: 0.3rem;
            margin: 0.02rem auto;
            pointer-events: none !important;
        }
        .divs {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 0.3rem;
            height: 0.3rem;
            // https://ycgshop.oss-cn-beijing.aliyuncs.com/2022-04-08/1649384031533.png
            // background-image:url("2022-04-25/1650875966939.png");
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue